<template>
  <b-card no-body>
    <b-card-header>
      <div>
        <b-card-title class="mb-1">
          <b-card-title>Active Users - {{activeUser}}</b-card-title>
        </b-card-title>
      </div>
    </b-card-header>

    <b-card-body>
      <!-- <vue-apex-charts
        type="line"
        height="400"
        :options="apexChatData.lineChartSimple.chartOptions"
        :series="apexChatData.lineChartSimple.series"
      /> -->
       <vue-apex-charts
        type="line"
        height="400"
        :options="getOption"
        :series="getData"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BBadge,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import apexChatData from './apexChartData'
import { mapGetters } from "vuex";
import { $themeColors } from '@themeConfig'
export default {
  components: {
    VueApexCharts,
    BCardHeader,
    BCard,
    BBadge,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
  },
  data() {
    return {
      apexChatData,
      
    }
  },
   computed: {
    ...mapGetters({ 
      allUserData: "user/allUserData",
      lastSixmonthUserArray:"user/lastSixmonthUser",
    }),
    getData(){
      var self = this;
       let series = [
          {
            data: self.lastSixmonthUserArray.data,
          },
        ]
      
      return series;
    },
    getOption(){
      var self = this;
       let chartOptions = {
        chart: {
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        markers: {
          strokeWidth: 7,
          strokeOpacity: 1,
          strokeColors: [$themeColors.light],
          colors: [$themeColors.warning],
        },
        colors: [$themeColors.warning],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
        },
        grid: {
          xaxis: {
            lines: {
              show: true,
            },
          },
        },
        tooltip: {
          custom(data) {
            return `${'<div class="px-1 py-50"><span>'}${
              data.series[data.seriesIndex][data.dataPointIndex]
            }</span></div>`
          },
        },
        xaxis: {
          categories: self.lastSixmonthUserArray.month
        },
        yaxis: {
          // opposite: isRtl,
        },
      }
        return chartOptions;
    },
     activeUser(){
      var self = this;
      let userArray = [];
      if(self.allUserData.length > 0){
        self.allUserData.forEach(data => {
          if(data.userRole != 'admin' && data.status == 2){
            userArray.push(data);
          }
        })
        if(userArray.length > 0){
          return userArray.length
        }else{
          return "0";
        }
      }else{
        return "0";
      }
    },
   }
}
</script>
<style>
.apexcharts-xaxistooltip{
  display:none !important;
}
</style>
